/* eslint-disable @angular-eslint/prefer-inject */
/** @format */

import { ISameDayDataList } from '@cart-checkout/data-access/interfaces';
import { filter, map } from 'rxjs/operators';

import { CheckoutAnalyticsService } from './checkout.analytics.service';
import { CartItem, ICartItem } from '@shared/data-access/interfaces';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StoreDao } from '../store/store.dao';

@Injectable({
  providedIn: 'root',
})
export class AvailabilityService {
  constructor(
    private storeDao: StoreDao,
    private checkoutAnalyticsService: CheckoutAnalyticsService,
  ) {}

  private analtyicsData: any;
  private invAnalytics = [];

  public getItemQuantities(items: any) {
    const availabilityParams = this.getSkusAndLocationsFromCartItems(items);
    return this.storeDao
      .getSkuInventoryByLocation$(availabilityParams.skus, availabilityParams.locations)
      .pipe(
        map((inventoryAvail) => {
          const stockQty = {};
          for (const item of items) {
            stockQty[item.sku] = this.checkLowInventory(item.sku, inventoryAvail, item.bopis_store);
          }
          this.checkoutAnalyticsService.setProperty('stockQty', this.invAnalytics);
          this.checkoutAnalyticsService.triggerCheckoutActionEvent('stockQty ready');
          return stockQty;
        }),
      );
  }

  public getSameDayAvailability$(
    items: ICartItem[] | CartItem[],
    zipCode: string,
  ): Observable<ISameDayDataList> {
    const sameDayavailabilityParams: { skus: string[] } =
      this.getSkusAndLocationsFromCartItems(items);
    return this.storeDao.getSameDayAvailability$(zipCode, sameDayavailabilityParams.skus).pipe(
      filter((res) => !!res?.skuAvailability?.length),
      map((inventoryAvail) => {
        const stockQty = {} as ISameDayDataList;
        for (const invtory of inventoryAvail.skuAvailability) {
          let lowStockMessage = null;
          const analtyicsData = {
            SDDLowStockMessageShown: false,
            BOPISLowStockQty: invtory.sameDayQuantity,
            sku: invtory.sku,
          };

          if (invtory.sameDayQuantity < 10) {
            analtyicsData.SDDLowStockMessageShown = true;
            lowStockMessage = `Only ${invtory.sameDayQuantity} left!`;
          }

          stockQty[invtory.sku] = {
            sameDayInventory: invtory.sameDayQuantity,
            sameDayEligible: invtory.sameDayEligible,
            lowStockMessage,
          };
          this.invAnalytics.push(analtyicsData);
        }
        this.checkoutAnalyticsService.setProperty('stockQty', this.invAnalytics);
        this.checkoutAnalyticsService.triggerCheckoutActionEvent('stockQty ready');
        return stockQty;
      }),
    );
  }

  public getSDDEligibleItemsCount(inventoryAvail: ISameDayDataList): number {
    return Object.keys(inventoryAvail).filter(
      (item) =>
        !inventoryAvail[item].sameDayEligible ||
        (inventoryAvail[item].sameDayEligible && inventoryAvail[item].sameDayInventory <= 0),
    ).length;
  }

  /**
   * @description returns a map of skus and inventory to pass to the availability API for an inventory request
   * @param items items in the cart
   */
  private getSkusAndLocationsFromCartItems(items: any[]): any {
    const skus = [];
    const locations = [];

    for (let i = 0; i < items.length; i++) {
      const currentItem = items[i];
      skus.push(currentItem.sku);
      locations.push(currentItem.bopis_store || '0');
    }

    return {
      skus: [...new Set(skus)],
      locations: [...new Set(locations)],
    };
  }

  private checkLowInventory(sku: string, inventoryAvail: any, bopisStore = '0'): string {
    // temporary logic for cart page on v2 of availability call. can be removed when cart goes to v4.
    let invAvail = inventoryAvail;
    if (inventoryAvail.data !== undefined) {
      invAvail = inventoryAvail.data.skus;
    }
    for (const inv of invAvail) {
      if (sku === inv.sku && bopisStore === inv.location) {
        let lowMessagingText = '';

        // if bopis set bopis analytics
        if (bopisStore !== '0') {
          this.analtyicsData = {
            BOPISLowStockMessageShown: false,
            BOPISLowStockQty: inv.atsqty,
            sku: inv.sku,
          };

          lowMessagingText = this.setLowMessagingText(true, inv.atsqty);
        } else {
          this.analtyicsData = {
            STHLowStockMessageShown: false,
            STHLowStockQty: inv.atsqty,
            sku: inv.sku,
          };

          lowMessagingText = this.setLowMessagingText(false, inv.atsqty);
        }

        this.invAnalytics.push(this.analtyicsData);

        return lowMessagingText;
      }
    }

    return '';
  }

  // Used only for BOPIS/BOPL and STH
  private setLowMessagingText(isBopis: boolean, stockQty: string) {
    if (parseInt(stockQty, 10) < 10) {
      if (isBopis) {
        this.analtyicsData.BOPISLowStockMessageShown = true;
        return `Only ${stockQty} left!`;
      }

      this.analtyicsData.STHLowStockMessageShown = true;
      return `Only ${stockQty} available to ship!`;
    }
  }
}
